import React from 'react';
import { Edit, SimpleForm, DisabledInput, TextInput } from 'react-admin';
import CardActions from '@material-ui/core/CardActions';
import { ListButton, DeleteButton, EditButton } from 'react-admin';
import PersonalizePageForm from '../../components/PersonalizePageForm';
import Chip from '@material-ui/core/Chip';
import CustomForm from '../../components/CustomForm';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

export const PageEdit = (props) => (
    <Edit title={<PageTitle />} actions={<PageActions />} {...props}>
        <CustomForm toolbar={null} options={{ fullWidth: true }}>
            <PersonalizePageForm source="id" options={{ fullWidth: true }} />
        </CustomForm>
    </Edit>
);

const PageTitle = ({ record }) => {
    // return (
    //     <ListItemText 
    //     primary={`Personalizing ${record ? record.title : ''} page`}
    //     secondary={'Resolving low VpV for Urban Hipster segment'} />);
    return (
        <div>
            <h5>{`Personalizing ${record ? record.title : ''} page`}</h5>
            <h6>Resolving low VpV for Urban Hipster segment</h6>
        </div>);
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PageActions = ({ data, resource }) => (
    <CardActions style={cardActionStyle}>
        {/* <ListButton basePath={basePath} />
        <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    </CardActions>
);


// WEBPACK FOOTER //
// ./src/pages/edit/Page.js